'use client';
import styled from 'styled-components';
import { Button } from '@ui/button';

export const StyledCheckoutButton = styled(Button)`
  background-color: black;
  color: ${({ theme }) => theme.colors.neutral.white};
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  vertical-align: middle;
`;

export const LogoContainer = styled.div`
  display: flex;
  margin-left: 5px;
`;
